import {ExperienceLevelEnum, FitnessGoalEnum, GenderEnum} from './members-categories-enums';

export class Properties {

  //For Image download Urls
  static readonly LOGO = 'logo';
  static readonly ADVERTISEMENT = 'advertisement';
  static readonly GYM_EVENT = 'gym event';
  static readonly PROFILE_IMAGE = 'profile image';

  static readonly experienceLevel = {
    PERSONAL_TRAINER: 'I\'m a personal trainer'
  }

  static readonly submitResult = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    UNSUBMITTED: ''
  }

  static readonly adminEmails = ['root@gogymbuddy.com'];

  static readonly TARGETED_MESSAGING_OPTIONS = {
    ATTENDANCE_GOALS: [1, 2, 3, 4, 5, 6],
    EXPERIENCE_LEVELS: [ExperienceLevelEnum.ZERO, ExperienceLevelEnum.ONE, ExperienceLevelEnum.TWO, ExperienceLevelEnum.THREE, ExperienceLevelEnum.FOUR, ExperienceLevelEnum.FIVE],
    FITNESS_GOALS: [FitnessGoalEnum.ZERO, FitnessGoalEnum.ONE, FitnessGoalEnum.TWO, FitnessGoalEnum.THREE, FitnessGoalEnum.FOUR, FitnessGoalEnum.FIVE, FitnessGoalEnum.SIX, FitnessGoalEnum.SEVEN, FitnessGoalEnum.SEVEN, FitnessGoalEnum.EIGHT, FitnessGoalEnum.NINE],
    GENDER: [GenderEnum.MALE, GenderEnum.FEMALE],
    DATE_OF_BIRTH: []
  }

  static readonly TARGETED_MESSAGING_VALUES = {
    ATTENDANCE_GOALS : 'attendance_goal',
    EXPERIENCE_LEVELS : "exp",
    FITNESS_GOALS : "goal",
    GENDER : 'gender',
    DATE_OF_BIRTH: 'dob'
  }

}





// WEBPACK FOOTER //
// ./src/app/_utils/properties.ts